import {z as zod} from "zod";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";

export type BlogsWorkspaceCapabilityConfiguration = {
    leadGenerationWidgetEnabled?: boolean;
    productAddToCartTemplateId?: Uuid;
};

export const blogsWorkspaceCapabilityConfigurationValidator: zod.ZodType<BlogsWorkspaceCapabilityConfiguration> = zod.strictObject({
    leadGenerationWidgetEnabled: zod.boolean().optional(),
    productAddToCartTemplateId: uuidZodValidator.optional(),
});
